module.exports = __webpack_public_path__ + "img/mail-sp.25b77fcd.png";